<template>
    <div class="contacts-contacts">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="8" sm="8" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Contatos</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="4" sm="4" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <div class="submenu">
                    <mu-menu cover placement="left-start" class="menu-mobile">
                        <mu-button icon>
                            <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
                        </mu-button>
                        <mu-list slot="content" class="mu-list-custom">
                            <mu-list-item button v-for="(item, key) in submenu" :to="{ name: item.route }" :color="item.color" :textColor="item.textColor" :key="key">
                                <mu-list-item-title>{{ item.name }}</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon :icon="item.icon" class="icon-md"/></mu-list-item-action>
                            </mu-list-item>
                        </mu-list>
                    </mu-menu>
                    <div class="menu-desktop">
                        <mu-flex>
                            <mu-button v-for="(item, key) in submenu" :to="{ name: item.route }" round :color="item.color" :textColor="item.textColor" :key="key">
                                <font-awesome-icon :icon="item.icon" class="icon-md icon-margin-left"/>
                                {{ item.name }}
                            </mu-button>
                        </mu-flex>
                    </div>
                </div>

            </mu-col>
        </mu-row>

        <!-- Busca -->
        <div class="search">
            <mu-form :model="filter">
                <mu-paper :z-depth="1">
                    <mu-row gutter>
                        <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                            <mu-text-field v-model="filter.name" full-width @keyup.enter="load()" label="Nome"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                            <mu-text-field v-model="filter.phone" full-width @keyup.enter="load()" label="Telefone"></mu-text-field>
                        </mu-col>
                        <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                            <mu-select label="Status" v-model="filter.status" full-width>
                                <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                            <mu-select label="Grupo" v-model="filter.group" full-width>
                                <mu-option v-for="(option, key) in options.groups" :key="key" :label="option.name" :value="option.id"></mu-option>
                            </mu-select>
                        </mu-col>
                        <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                            <div class="padding-top">
                                <mu-button round color="secondary" @click="load()">
                                    <font-awesome-icon icon="search" class="icon-md icon-margin-left"/>
                                    Filtrar
                                </mu-button>
                                <mu-button round @click="filterClear()">
                                    <font-awesome-icon icon="times" class="icon-lg icon-margin-left"/>
                                    Limpar
                                </mu-button>
                            </div>
                        </mu-col>
                    </mu-row>
                </mu-paper>
            </mu-form>
        </div>

        <!-- Lista de contatos -->
        <div class="contacts" v-if="!contacts.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos contatos tablet/desktop -->
                <mu-data-table :columns="contacts.columns" :data="contacts.list" @row-click="edit" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros de contato.
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.firstname }} {{ scope.row.lastname }}</td>
                        <td>{{ scope.row.phone }}</td>
                        <td class="is-center">{{ scope.row.groups ? scope.row.groups.length : '' }}</td>
                        <td class="is-center">
                            <mu-badge content="Contato Bloqueado" color="#000" v-if="scope.row.blacklist"></mu-badge>
                        </td>
                        <td class="is-center">
                            <mu-badge content="Inativo" v-if="scope.row.status == 'I'"></mu-badge>
                            <mu-badge content="Ativo" color="success" v-if="scope.row.status == 'A'"></mu-badge>
                        </td>
                    </template>
                </mu-data-table>

                <!-- Listagem de contatos mobile -->
                <mu-list textline="three-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in contacts.list" :key="key">
                        <mu-list-item button :to="{ name: 'app.contacts.contacts.edit', params: { id: item.id } }">
                            <mu-list-item-content>
                                <mu-list-item-title>{{ item.firstname }} {{ item.lastname }}</mu-list-item-title>
                                <mu-list-item-sub-title>
                                    {{ item.phone }} <br>
                                    <mu-badge content="Inativo" v-if="item.status == 'I'"></mu-badge>
                                    <mu-badge content="Ativo" color="success" v-if="item.status == 'A'"></mu-badge>
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <font-awesome-icon icon="pen" class="icon-md icon-margin-left"/>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="contacts.paging.total > contacts.paging.size">
                <mu-pagination :total="contacts.paging.total" :page-count="5" :page-size="contacts.paging.size" :current.sync="contacts.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando a lista de contatos" v-if="contacts.loading"></mu-loading>

    </div>
</template>

<script>
    import ContactsServices from '@/services/contacts/contacts'
    import GroupsServices from '@/services/contacts/groups'

    export default {
        name: 'app-contacts-contacts-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Meus Contatos',
                        disabled: true
                    }
                ],
                options: {
                    groups: [],
                    status: [
                        { label: 'Inativo', value: 'I' },
                        { label: 'Ativo', value: 'A' }
                    ]
                },
                submenu: [
                    {
                        name: 'Criar Contato',
                        icon: 'plus',
                        route: 'app.contacts.contacts.create',
                        color: 'primary',
                        textColor: null
                    }
                ],
                filter: {
                    name: '',
                    phone: '',
                    status: '',
                    group: null
                },
                contacts: {
                    loading: false,
                    paging: {
                        total: 0,
                        size: 10,
                        page: 1
                    },
                    columns: [
                        { title: 'Nome', name: 'firstname' },
                        { title: 'Telefone', name: 'phone' },
                        { title: 'Grupos', name: 'groups', align: 'center' },
                        { title: 'Contato Bloqueado', name: 'blacklist', align: 'center' },
                        { title: 'Status', name: 'status', align: 'center' }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        async created () {
            await this.load()
            await this.loadGroups()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Quando clicado sobre o item é chamado essa função que redireciona para
             * a pagina de edição do item
             */
            edit (index, row, event) {
                this.$router.push({ name: 'app.contacts.contacts.edit', params: { id: row.id } }).catch(err => { if (err) console.log(err.name || '') })
            },

            /**
             * Carrega a lista de contatos passando alguns filtros relacionados
             * a busca e paginação
             */
            async load () {
                try {
                    this.contacts.loading = true

                    let query = {
                        page: this.contacts.paging.page
                    }
                    if (this.filter.name) {
                        query.name = this.filter.name
                    }
                    if (this.filter.phone) {
                        query.phone = this.filter.phone
                    }
                    if (this.filter.status) {
                        query.status = this.filter.status
                    }
                    if (this.filter.group > 0) {
                        query.group = this.filter.group
                    }

                    let result = await ContactsServices.findAll(query)

                    if (result && result.status) {
                        this.contacts.paging.page = result.currentPage
                        this.contacts.paging.total = result.rowCount
                        this.contacts.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.contacts.loading = false
                }
            },

            async loadGroups () {
                try {
                    let result = await GroupsServices.all()

                    if (result && result.status) {
                        this.options.groups = result.results
                        return
                    }

                    this.$eventHub.$emit('snackbar', 'error', result.message, false)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os grupos.')
                } finally {
                    // this.contacts.loading = false
                }
            },

            /**
             * Limpa os campos do filtro e refaz o load original
             */
            filterClear () {
                this.filter = {
                    name: '',
                    phone: '',
                    status: '',
                    group: null
                }
                this.contacts.paging.page = 1
                this.contacts.paging.size = 15
                this.load()
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .search
        text-align center
        margin 20px 0

        .row
            .mu-input
                margin-bottom 0

        .mu-paper
            padding 10px 20px 20px 20px

        .padding-top
            padding-top 28px

    .contacts
        margin 20px 0

        .mu-list
            padding 0

        a
            color inherit
            text-decoration underline

        td
            cursor pointer

        .row
            margin 0 20px
            padding 15px 0

            .text-right
                text-align right

        .paginate
            padding 20px

        .mu-paper
            padding 0px

    .submenu
        float right

        .mu-button
            margin-left 5px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .search
            text-align left !important
</style>
